<template>
  <ErrorModal />
  <div class="content" style="padding:2rem 0;" v-if="!isAuthenticated">
    <Card>
      <template #icon></template>
      <template #title>Welcome to the<br />Protractor Companion App</template>
      <template #content>
        <p>Protractor works to bring leading edge technology to automotive aftermarket repair shops and tire stores.</p>
        <p><strong>VIN scanner</strong><br />Enables you to capture a picture of the VIN and save it directly to the work order.</p>
        <p><i>Planned features</i> - Digital Vehicle Inspection, Reporting, Time Clock, to name a few.</p>
        <h3>Not a Protractor user?</h3>
        <a href="https://www.protractorsoftware.com/contact/" target="_blank"><Button label="Book a Demo" class="p-button-rounded color: btn-primary" icon="pi pi-arrow-right" iconPos="right" /></a>
        <h3>Want to learn more?</h3>
        <a href="https://www.protractorsoftware.com" target="_blank"><Button label="Visit Protractor.com" class="p-button-rounded btn-primary" icon="pi pi-arrow-right" iconPos="right" /></a>
        <h3>Already a Protractor user?</h3>
        <a href="https://www.protractorsoftware.com/contact/" target="_blank"><Button label="Request a Login" class="p-button-rounded btn-primary" icon="pi pi-arrow-right" iconPos="right" /></a>
      </template>
    </Card>
  </div>

  <!-- accept all roles except EA and SuA, special case for EnterpriseAdmin acting as StoreAdmin -->
  <StoreHome v-if="(store.state.role && !['EnterpriseAdmin', 'SupportAdmin'].includes(store.state.role)) ||
    store.state.isStoreLogin"
  />
  <EnterpriseHome v-if="store.state.role === 'EnterpriseAdmin' && !store.state.isStoreLogin" />
  <EnterpriseStoreError v-if="isAuthenticated && enterprisestoreerror" />
</template>

<script lang="ts" setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";

import StoreHome from "./StoreHome.vue";
import EnterpriseHome from "./EnterpriseHome.vue";
import ApiService from "@/service/api.service";

const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
const enterprisestoreerror = ref(false);
const store = useStore();
onMounted(async () => {
  if (isAuthenticated.value === true) {
    await getUserInfo();
  }
})

// watch isLoading and isAuthenticated object to handle auth0 successful login - for initial login
const stop = watch([isLoading, isAuthenticated], async ([loading, auth]) => {
  if (!loading && auth) {
    await getUserInfo();
    stop();
  }
});

const getUserInfo = async() => {
  const accessToken = await getAccessTokenSilently();
  await ApiService.getUserInfo(accessToken);
}
</script>
